'use client'

import React, { PropsWithChildren, memo } from 'react'

// styled
import { LayoutWithBackGroundNeutral } from './styled'
import { HogProvider, Toast } from '@/libs/react-components'


const isOptOutUserAgentFilter = process.env.NEXT_PUBLIC_POSTHOG_OPT_OUT_USERAGENT_FILTER === '1'

const Layout = ({ children }: PropsWithChildren) => {

    return (
        <HogProvider
            posthogConfig={{
                key: process.env.NEXT_PUBLIC_POSTHOG_API_KEY ?? '',
                host: process.env.NEXT_PUBLIC_POSTHOG_API_HOST ?? '',
                options: {
                    optOutUserAgentFilter: isOptOutUserAgentFilter
                }
            }}
        >
            <LayoutWithBackGroundNeutral>
                {children}
                <Toast />
            </LayoutWithBackGroundNeutral>
        </HogProvider>
    )
}

export default memo(Layout)
